const themeColours = {
  race: [
    { label: 'Black African', colour: 'rgb(96,178,96)' },
    { label: 'Coloured', colour: 'rgb(244,185,37)' },
    { label: 'Indian or Asian', colour: 'rgb(234,73,52)' },
    { label: 'White', colour: 'rgb(178,112,229)' },
    { label: 'Other', colour: 'rgb(119,119,119)' }
  ],
  lang: [
    { label: 'Afrikaans', colour: 'rgb(128,177,211)' },
    { label: 'English', colour: 'rgb(251,128,114)' },
    { label: 'isiNdebele', colour: 'rgb(82,178,62)' },
    { label: 'isiXhosa', colour: 'rgb(180,157,0)' },
    { label: 'isiZulu', colour: 'rgb(141,211,199)' },
    { label: 'Sepedi', colour: 'rgb(253,180,98)' },
    { label: 'Sesotho', colour: 'rgb(249,151,201)' },
    { label: 'Setswana', colour: 'rgb(179,222,105)' },
    { label: 'siSwati', colour: 'rgb(188,128,189)' },
    { label: 'Tshivenḓa', colour: 'rgb(190,186,218)' },
    { label: 'Xitsonga', colour: 'rgb(255,255,179)' },
    { label: 'Other', colour: 'rgb(119,119,119)' }
  ],
  hhinc: [
    { label: 'R0 – R4,800', colour: 'rgb(251,128,114)' },
    { label: 'R4,801 – R19,600', colour: 'rgb(253,180,98)' },
    { label: 'R19,601 – R76,400', colour: 'rgb(179,222,105)' },
    { label: 'R76,401 – R307,600', colour: 'rgb(141,211,199)' },
    { label: 'R307,601 – R1,228,800', colour: 'rgb(128,177,211)' },
    { label: 'R1,228,801 +', colour: 'rgb(188,128,189)' }
  ]
}

export default themeColours
